import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { CustomTrace } from 'src/Libs/chart-kit/shared/utils/chartModel'
import { getTraceName } from 'src/Libs/system-charts/shared/utils/getTraceName'
import { traceConf, TraceConf, TraceKey } from 'src/Libs/system-charts/shared/config/traceConf'
import { useTypedSelector } from 'src/State/RootReducer'
import { useWallboxHardwareByStorage } from 'src/Libs/wallboxes/hooks'

export interface TraceDetails {
  name: string
  key: TraceKey
  alternateKey?: string
  configuration: TraceConf
}

interface UseChartTracesHook {
  /**
   * Returns translated name, key, alternative key and configuration of a default trace
   * @param traceKey alternativeKey of a trace
   */
  getTraceInfoFromName: (traceKey: TraceKey) => TraceDetails
}

const useChartTraces = (): UseChartTracesHook => {
  const { t } = useCustomTranslation()
  const { data: wallboxHardware } = useWallboxHardwareByStorage()
  const powermeterHardware = useTypedSelector(store => store.storage.powermeterHardware)

  const getTraceInfoFromName = (traceKey: TraceKey): { name: string; key: TraceKey; alternateKey?: string; configuration: TraceConf } => {
    const traceWithId = traceKey.startsWith('wb') || traceKey.startsWith('pm')
    const isWallboxOrPowermeter = traceKey.includes('Wallbox') || traceKey.includes('Powermeter')
    const splittedTrace = traceKey.split('/')
    const splittedTraceKey = splittedTrace[1] as TraceKey
    const configuration = { ...traceConf[traceWithId ? splittedTraceKey : traceKey], key: traceKey }

    if (isWallboxOrPowermeter) configuration.custom.alternateKey = traceKey

    const traceName = configuration.custom
      ? getTraceName(t, configuration.custom as CustomTrace, wallboxHardware, powermeterHardware)
      : splittedTraceKey
    const key = traceWithId ? splittedTraceKey : traceKey
    const alternateKey = traceWithId ? traceKey : isWallboxOrPowermeter ? configuration.custom.alternateKey : undefined

    return { name: traceName, key, alternateKey, configuration }
  }

  return { getTraceInfoFromName }
}

export default useChartTraces
